import React from 'react';
import { FlameIcon, ZapIcon } from 'lucide-react';
import { PRODUCT_IMAGE, stats } from '../../data/content';
import { CtaBlock } from '../CtaBlock';
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-ink-950" data-id="element-143" data-mp="cw4cbt4fqmtv">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-[520px] opacity-25" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/patterns/generated-images/322cf731-7c5c-455c-8e40-74575702962d.jpg)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      maskImage: 'linear-gradient(#000 20%, transparent 100%)',
      WebkitMaskImage: 'linear-gradient(#000 20%, transparent 100%)'
    }} aria-hidden="true" data-id="element-144" data-mp="cxxo1mtwnx8q" />

      <div className="relative z-10 bg-spark-500 px-4 py-2.5 text-center" data-id="element-145" data-mp="15kifsoeambct">
        <p className="flex flex-wrap items-center justify-center gap-x-2 text-[11px] font-extrabold uppercase leading-tight tracking-wide text-ink-950 sm:text-sm" data-id="element-146" data-mp="15ifeh87owvss">
          <FlameIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-147" data-mp="9oly4akoc0nw" />
          Offre de lancement
          <span className="text-ink-950/60" data-id="element-148" data-mp="4ny8ntc3frvs">·</span>
          Accès à vie pour seulement 19 €
        </p>
      </div>

      <div className="relative z-10 mx-auto max-w-3xl px-4 pb-14 pt-8 sm:pt-12" data-id="element-149" data-mp="3vvj1xy19z6lu">
        <div className="flex flex-col items-center text-center" data-id="element-150" data-mp="3ruqunabyrbs7">
          <span className="inline-flex items-center gap-1.5 rounded-full border border-arc-500/40 bg-arc-500/10 px-3 py-1 text-[10px] font-bold uppercase tracking-[0.2em] text-arc-400" data-id="element-151" data-mp="se0vnv15i7nj">
            <ZapIcon className="h-3 w-3" aria-hidden="true" data-id="element-152" data-mp="iohdkrl9ihtq" />
            Guide de référence
          </span>

          <h1 className="mt-4 font-display text-[2.6rem] font-bold uppercase leading-[0.92] tracking-tight text-white sm:text-6xl" data-id="element-153" data-mp="en5oqoa7q0ml">
            Système <span className="text-arc-400" data-id="element-154" data-mp="1b6cyeivpvay7">Maître</span>
            <br data-id="element-155" data-mp="16ebp95tui0ce" />
            de Soudage™
          </h1>

          <p className="mt-4 text-balance text-lg font-bold leading-snug text-spark-400 sm:text-2xl" data-id="element-156" data-mp="16csajjnu7xcq">
            Arrêtez d’improviser et obtenez des cordons de soudure solides et propres
          </p>

          <p className="mt-4 max-w-xl text-balance text-[15px] leading-relaxed text-white/70 sm:text-base" data-id="element-157" data-mp="35k8s4y0cj9l9">
            Oubliez les essais et erreurs, les réglages compliqués et les vidéos
            interminables. Le Système Maître de Soudage™ vous guide pas à pas pour régler
            votre poste à souder, éviter les erreurs de débutant et souder avec confiance
            dès vos premières réalisations.
          </p>

          <div className="mt-7 w-full" data-id="element-158" data-mp="27x9r6b2mffhk">
            <img src={PRODUCT_IMAGE} alt="Système Maître de Soudage™ — 6 manuels, bonus et accès numérique" className="mx-auto w-full max-w-lg drop-shadow-[0_25px_45px_rgba(41,171,226,0.25)]" data-id="element-159" data-mp="27yjq12hasrp9" />
          </div>

          <div className="mt-6 w-full" data-id="element-160" data-mp="b4pylb47esk3">
            <CtaBlock id="cta-hero" label="Je veux le Système Maître maintenant" note="" data-id="element-161" data-mp="b3oqnfihim6l" />
          </div>

          <ul className="mt-5 grid w-full max-w-md grid-cols-2 gap-2 text-left" data-id="element-162" data-mp="1qo7c1xgnlvw6">
            {['Accès immédiat', 'Paiement unique', 'Accès à vie', 'Garantie de 7 jours'].map(item => <li key={item} className="flex items-center gap-1.5 text-xs font-semibold text-white/75 sm:text-sm" data-id="element-163" data-mp="20k0olgudhpdy">
                <span className="text-arc-400" aria-hidden="true" data-id="element-164" data-mp="2aavd6rv3d12k">
                  ✓
                </span>
                {item}
              </li>)}
          </ul>

          <p className="mt-7 max-w-lg text-balance text-sm font-medium italic leading-relaxed text-white/55" data-id="element-165" data-mp="2jc3bh9xly1wn">
            Plus qu’une formation… un guide de référence à consulter chaque fois que vous
            allez souder.
          </p>
        </div>

        <dl className="mt-9 grid grid-cols-2 gap-2.5 sm:grid-cols-4" data-id="element-166" data-mp="p0oimk9avmco">
          {stats.map(s => <div key={s.label} className="rounded-xl border border-white/10 bg-ink-800/70 px-3 py-4 text-center" data-id="element-167" data-mp="qhtujqdrd2r4">
              <dt className="sr-only" data-id="element-168" data-mp="10eyle3ijtme9">{s.label}</dt>
              <dd data-id="element-169" data-mp="10c2o8heiz1qv">
                <span className="block font-display text-3xl font-bold leading-none text-arc-400 sm:text-4xl" data-id="element-170" data-mp="15cqakprt6uer">
                  {s.value}
                </span>
                <span className="mt-1.5 block text-[10px] font-bold uppercase leading-tight tracking-wider text-white/55" data-id="element-171" data-mp="7r2nwwl5nqgf">
                  {s.label}
                </span>
              </dd>
            </div>)}
        </dl>
      </div>
    </header>;
}